export var ESocialLoginProvider;
(function (ESocialLoginProvider) {
    ESocialLoginProvider["Apple"] = "Apple";
    ESocialLoginProvider["Facebook"] = "Facebook";
    ESocialLoginProvider["Google"] = "Google";
    ESocialLoginProvider["SosPortal"] = "SosPortal";
})(ESocialLoginProvider || (ESocialLoginProvider = {}));
export class SocialLoginProvidersViewModelFactory {
    static createLinkedSocialPlatformsFromDto(dto) {
        return {
            [ESocialLoginProvider.Apple]: dto.includes(ESocialLoginProvider.Apple),
            [ESocialLoginProvider.Facebook]: dto.includes(ESocialLoginProvider.Facebook),
            [ESocialLoginProvider.Google]: dto.includes(ESocialLoginProvider.Google),
        };
    }
}
//# sourceMappingURL=social-login-providers.view-model.js.map